module.exports = __webpack_public_path__ + "img/button2.47295c88.png";